// extracted by css-extract-rspack-plugin
export default {"TimeTrackingLabel":"opportunity-form-notifications-enabled-checkbox_TimeTrackingLabel__NDoWv"};